<div class="events-list-page">
  <header class="page-header">
    <div class="header-top">
      <h1>Liste des événements</h1>
      <button type="button" class="btn-create" (click)="createEvent()">+ Créer</button>
    </div>
    <div class="search-bar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input type="text" placeholder="Rechercher un événement..." (input)="onSearch($event)" />
    </div>
  </header>

  @if (error()) {
  <div class="error-banner">{{ error() }}</div>
  } @if (isLoading()) {
  <div class="loading">
    <div class="spinner"></div>
    Chargement...
  </div>
  } @else {

  <!-- Desktop table -->
  <div class="table-container desktop-only">
    <table>
      <thead>
        <tr>
          <th>Image</th>
          <th class="sortable" (click)="toggleSort('title')">
            Titre @if (sortBy() === 'title') {
            <span class="sort-icon">{{ sortDir() === 'asc' ? '↑' : '↓' }}</span>
            }
          </th>
          <th>Saloon</th>
          <th class="sortable" (click)="toggleSort('startDateTime')">
            Date @if (sortBy() === 'startDateTime') {
            <span class="sort-icon">{{ sortDir() === 'asc' ? '↑' : '↓' }}</span>
            }
          </th>
          <th>Intéressés</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (event of events(); track event.id) {
        <tr>
          <td>
            <img class="event-thumb" [src]="event.imageUrl" [alt]="event.title" loading="lazy" />
          </td>
          <td>
            <strong>{{ event.title }}</strong>
            @if (event.subTitle) {
            <br /><small>{{ event.subTitle }}</small>
            }
          </td>
          <td>{{ event.saloonName }}</td>
          <td>{{ formatDate(event.startDateTime) }}</td>
          <td>
            <span class="interested-badge"> ⭐ {{ event.interestedCount ?? 0 }} </span>
          </td>
          <td>
            <span class="badge" [class.active]="event.isActive" [class.inactive]="!event.isActive">
              {{ event.isActive ? 'Actif' : 'Inactif' }}
            </span>
          </td>
          <td>
            <div class="actions">
              <button
                type="button"
                class="btn-action toggle"
                (click)="toggleActive(event)"
                [title]="event.isActive ? 'Désactiver' : 'Activer'"
              >
                {{ event.isActive ? '⏸' : '▶' }}
              </button>
              <button type="button" class="btn-action edit" (click)="editEvent(event)">✏️</button>
              <button type="button" class="btn-action delete" (click)="confirmDelete(event)">
                🗑️
              </button>
            </div>
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="7" class="empty-table">Aucun événement trouvé</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Mobile cards -->
  <div class="mobile-cards mobile-only">
    @for (event of events(); track event.id) {
    <div class="event-card-admin">
      <div class="card-header">
        <img [src]="event.imageUrl" [alt]="event.title" loading="lazy" />
        <div class="card-info">
          <strong>{{ event.title }}</strong>
          <small>{{ event.saloonName }}</small>
          <small>{{ formatDate(event.startDateTime) }}</small>
          <small class="interested-badge-mobile"
            >⭐ {{ event.interestedCount ?? 0 }} intéressé{{
              (event.interestedCount ?? 0) > 1 ? 's' : ''
            }}</small
          >
        </div>
        <span class="badge" [class.active]="event.isActive" [class.inactive]="!event.isActive">
          {{ event.isActive ? 'Actif' : 'Inactif' }}
        </span>
      </div>
      <div class="card-actions">
        <button type="button" class="btn-action toggle" (click)="toggleActive(event)">
          {{ event.isActive ? '⏸ Désactiver' : '▶ Activer' }}
        </button>
        <button type="button" class="btn-action edit" (click)="editEvent(event)">
          ✏️ Modifier
        </button>
        <button type="button" class="btn-action delete" (click)="confirmDelete(event)">
          🗑️ Supprimer
        </button>
      </div>
    </div>
    } @empty {
    <div class="empty-state">Aucun événement trouvé</div>
    }
  </div>

  <!-- Pagination -->
  @if (totalPages() > 1) {
  <div class="pagination">
    <button type="button" [disabled]="currentPage() === 0" (click)="goToPage(currentPage() - 1)">
      ← Précédent
    </button>
    <span>Page {{ currentPage() + 1 }} / {{ totalPages() }}</span>
    <button
      type="button"
      [disabled]="currentPage() >= totalPages() - 1"
      (click)="goToPage(currentPage() + 1)"
    >
      Suivant →
    </button>
  </div>
  } }

  <!-- Delete confirmation modal -->
  @if (showDeleteModal && eventToDelete) {
  <div
    class="modal-overlay"
    role="button"
    tabindex="0"
    (click)="cancelDelete()"
    (keydown.escape)="cancelDelete()"
  >
    <div
      class="modal-content"
      role="document"
      tabindex="-1"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <h3>Confirmer la suppression</h3>
      <p>
        Êtes-vous sûr de vouloir supprimer l'événement <strong>{{ eventToDelete.title }}</strong> ?
      </p>
      <div class="modal-actions">
        <button type="button" class="btn-cancel" (click)="cancelDelete()">Annuler</button>
        <button type="button" class="btn-delete" (click)="deleteEvent()">Supprimer</button>
      </div>
    </div>
  </div>
  }
</div>
